import { render, staticRenderFns } from "./BookingViewImages.vue?vue&type=template&id=5332b65c&scoped=true&"
import script from "./BookingViewImages.vue?vue&type=script&lang=js&"
export * from "./BookingViewImages.vue?vue&type=script&lang=js&"
import style0 from "./BookingViewImages.vue?vue&type=style&index=0&id=5332b65c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5332b65c",
  null
  
)

export default component.exports